import { render, staticRenderFns } from "./BlockReview.vue?vue&type=template&id=72ee0916&"
import script from "./BlockReview.vue?vue&type=script&lang=js&"
export * from "./BlockReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports